export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : '数据暂时不可用，请稍后重试。';
}

export async function request<T>(url: string, signal?: AbortSignal): Promise<T> {
  const activeSignal = signal ?? AbortSignal.timeout(150_000);
  let response: Response;
  try { response = await fetch(url, { signal: activeSignal, cache: 'no-store' }); }
  catch (error) {
    if (activeSignal.aborted && activeSignal.reason?.name === 'TimeoutError') throw new Error('数据传输超时，请重试。');
    if (activeSignal.aborted) throw error;
    throw new Error(error instanceof DOMException && error.name === 'TimeoutError' ? '数据准备超时，请重试。' : '暂时无法连接数据服务，请稍后重试。');
  }
  const body = await response.json().catch(error => {
    // The fetch promise resolves on headers; body transfer can still time out or be interrupted.
    if (activeSignal.aborted && activeSignal.reason?.name === 'TimeoutError') throw new Error('数据传输超时，请重试。');
    if (activeSignal.aborted) throw error;
    if (error instanceof TypeError && response.ok) throw new Error('数据响应传输中断，请重试。');
    return null;
  });
  if (!response.ok) throw new Error(body?.error?.message ?? `请求未完成（${response.status}），请稍后重试。`);
  if (body === null) throw new Error('数据服务返回了无法读取的响应。');
  return body as T;
}
